import React, { Component } from "react";
import ReactDOM from "react-dom";
import {
  SortingState,
  IntegratedSorting,
  SearchState,
  IntegratedFiltering,
} from "@devexpress/dx-react-grid";
import {
  Grid,
  Table,
  TableHeaderRow,
  SearchPanel,
  Toolbar,
  TableColumnVisibility,
} from "@devexpress/dx-react-grid-bootstrap4";
import { PagingPanel } from "@devexpress/dx-react-grid-material-ui";
import "../../theme/styles/dx-react-grid-bootstrap4.css";
import "../../theme/styles/reactstrap.css";
import PropTypes from "prop-types";
import { connect } from "react-redux";
var styles = require("./Report.less");
import { DropdownButton, MenuItem, Button } from "react-bootstrap";
import * as commonActions from "./../../actions/commonActions";
import * as reportActions from "./../../actions/reportActions";
import { getPath } from "./../../actions/commonActions";
import moment from "moment-timezone";
import * as instrumentListActions from "./../../actions/instrumentListActions";
import "../../theme/styles/mediaqueries.css";
import Modal from "react-modal";
import { TcoDropdown } from "./../../components/UI/Dropdown/Dropdown";
import i18next from "i18next";
import config from "./../../config.js";
import * as filesaver from "./../../actions/FileSaver";
import ReactExport from "react-data-export";
import DateSelector from "./../DateSelector/DateSelector";
import { getSelectedDate } from "./../../utils/utils"; //import
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
let dataArray = [];
import {
  applyStyle,
  applyToHover,
  getSeparator,
  setDirection,
  unformatLang,
} from "./../../utils/utils";
import { withStyles } from "@material-ui/core/styles";
import * as currencyFormatter from "currency-formatter";
let separator;
let decimal;
let decimalCount = 0;
const elementsData = [
  {
    classNames: "trdAnafilterBar",
    elementType: "normal",
    applyTo: "single",
    tagNames: "div",
  },
  {
    classNames: "tradeAnalysisReportb1",
    elementType: "normal",
    applyTo: "single",
    tagNames: "div",
  },
  {
    classNames: "fltrBarInner",
    elementType: "normal",
    applyTo: "all",
    tagNames: "div",
  },
  {
    classNames: "reportsDropdown",
    elementType: "normal",
    applyTo: "all",
    tagNames: "button",
  },
  {
    classNames: "caret",
    elementType: "normal",
    applyTo: "all",
    tagNames: "span",
  },
  {
    classNames: "dropdown-menu",
    elementType: "normal",
    applyTo: "all",
    tagNames: "ul",
  },
  {
    classNames: "dropDownList",
    elementType: "tag",
    applyTo: "all",
    tagNames: "a",
  },
  {
    classNames: "glyphicon",
    elementType: "normal",
    applyTo: "all",
    tagNames: "span",
  },
  {
    classNames: "material-icons",
    elementType: "normal",
    applyTo: "all",
    tagNames: "i",
  },
  {
    classNames: "reportsTblGrid",
    elementType: "normal",
    applyTo: "all",
    tagNames: "div",
  },
  {
    classNames: "form-control",
    elementType: "normal",
    applyTo: "all",
    tagNames: "input",
  },
  {
    classNames: "oi-eye",
    elementType: "normal",
    applyTo: "all",
    tagNames: "span",
  },
  {
    classNames: "mdlWrap",
    elementType: "normal",
    applyTo: "all",
    tagNames: "div",
  },
  {
    classNames: "dropdown-toggle",
    elementType: "normal",
    applyTo: "all",
    tagNames: "button",
  },
  {
    classNames: "rateInput",
    elementType: "normal",
    applyTo: "single",
    tagNames: "input",
    parent: "SOAaccountList",
  },
  {
    classNames: "dx-g-bs4-table",
    elementType: "normal",
    applyTo: "all",
    tagNames: "table",
  },
  {
    classNames: "dx-g-bs4-header-cell",
    elementType: "tag",
    applyTo: "all",
    tagNames: "th",
  },
  {
    classNames: "dx-g-bs4-table-cell",
    elementType: "tag",
    applyTo: "all",
    tagNames: "td",
  },
  {
    classNames: "noDataCell",
    elementType: "tag",
    applyTo: "all",
    tagNames: "td",
  },
  {
    classNames: "trdAnalChkLabel",
    elementType: "normal",
    applyTo: "all",
    tagNames: "label",
  },
  {
    classNames: "closeBtn",
    elementType: "normal",
    applyTo: "single",
    tagNames: "div",
  },
];
const directionData = [
  {
    classNames: "commonGoBtn",
    elementType: "normal",
    applyTo: "single",
    tagNames: "div",
  },
  {
    classNames: "trdAnlDrpdownDiv",
    elementType: "normal",
    applyTo: "all",
    tagNames: "div",
  },
  {
    classNames: "card-header",
    elementType: "normal",
    applyTo: "single",
    tagNames: "div",
  },
  {
    classNames: "btnText",
    elementType: "normal",
    applyTo: "all",
    tagNames: "button",
  },
  {
    classNames: "dropdown-menu",
    elementType: "normal",
    applyTo: "all",
    tagNames: "ul",
  },
  {
    classNames: "reportsTblGrid",
    elementType: "normal",
    applyTo: "all",
    tagNames: "div",
  },
  {
    classNames: "allExportFilter",
    elementType: "normal",
    applyTo: "all",
    tagNames: "div",
  },
  {
    classNames: "trdwrapper1",
    elementType: "normal",
    applyTo: "all",
    tagNames: "div",
  },
  {
    classNames: "trdAnalChkLabel",
    elementType: "normal",
    applyTo: "all",
    tagNames: "label",
  },
];
@connect(
  (state) => ({
    DFA: state.auth.DFA,
    defAcc: state.dashboardRoot.dashboardReducer.defAcc,
    ACD: state.auth.ACD,
    trdAnalData: state.dashboardRoot.reportReducer.trdAnalData,
    socketDataStatic:
      state.dashboardRoot.instrumentListReducer.socketDataStatic,
    userDetail: state.auth.userDetail,
    trdAnalRptRandomNo: state.dashboardRoot.reportReducer.trdAnalRptRandomNo,
    selectedCssColorTheme:
      state.dashboardRoot.commonReducer.selectedCssColorTheme,
    selectedCssColor: state.dashboardRoot.commonReducer.selectedCssColor,
    localCurrency: state.dashboardRoot.instrumentListReducer.localCurrency,
    openCalender: state.dashboardRoot.commonReducer.openCalender,
    selectedLang: state.dashboardRoot.commonReducer.selectedLang,
    language: state.dashboardRoot.commonReducer.language,
    socketData: state.dashboardRoot.instrumentListReducer.socketData,
    stockCodeList: state.dashboardRoot.dashboardReducer.stockCodeList,
    loadAllRate: state.dashboardRoot.instrumentListReducer.loadAllRate,
    socketAllRate: state.dashboardRoot.instrumentListReducer.socketAllRate,
    stkCodeWisePair: state.dashboardRoot.commonReducer.stkCodeWisePair,
    dropdown: state.dashboardRoot.instrumentListReducer.dropdown,
    instData: state.dashboardRoot.instrumentListReducer.instData,
  }),
  {
    ...reportActions,
    ...instrumentListActions,
    ...commonActions,
  }
)
export default class ReportComponent extends Component {
  static propTypes = {
    getTradeanalysisReport: PropTypes.func,
    DFA: PropTypes.object,
    socketDataStatic: PropTypes.array,
    trdAnalData: PropTypes.object,
    userDetail: PropTypes.object,
    localCurrency: PropTypes.object,
    openCalender: PropTypes.boolean,
    onClickCalender: PropTypes.func,
    socketData: PropTypes.array,
    loadAllRate: PropTypes.bool,
    loadAllRateData: PropTypes.func,
    socketAllRate: PropTypes.array,
    stkCodeWisePair: PropTypes.array,
    dropdown: PropTypes.object,
    instData: PropTypes.array,
  };
  constructor(props) {
    super(props);
    this.state = {
      trdAnalysisRows: this.props.trdAnalData,
      currentDate: new Date().toLocaleDateString("en-US"),
      startDate: new Date().toLocaleDateString("en-US"),
      endDate: new Date().toLocaleDateString("en-US"),
      cmdtyPairList: [],
      pageSizes: [10, 15, 20, 0],
      cmdty_Desc: "",
      cmdty_Id: "",
      openBal: 0,
      openBalcheck: false,
      onlineTradecheck: false,
      swapTrdcheck: false,
      phoneTrdcheck: false,
      onlineTrade: 0,
      qty_type: "",
      swapTrd: 0,
      phoneTrd: 0,
      accountList: Array.from(this.props.ACD.values()),
      accountName: this.props.DFA.D,
      accountCode: this.props.DFA.C,
      ranges: {
        [i18next.t("today")]: [moment(), moment()],
        [i18next.t("yesterday")]: [
          moment().subtract(1, "days"),
          moment().subtract(1, "days"),
        ],
        [i18next.t("last7Days")]: [moment().subtract(6, "days"), moment()],
        [i18next.t("last30Days")]: [moment().subtract(29, "days"), moment()],
        [i18next.t("thisMonth")]: [
          moment().startOf("month"),
          moment().endOf("month"),
        ],
        [i18next.t("lastMonth")]: [
          moment().subtract(1, "month").startOf("month"),
          moment().subtract(1, "month").endOf("month"),
        ],
      },
      HiddentradeAnalysisCol: [],
      loadtableflag: true,
      isRefreshDisabled: true,
      isClearTrdAnalysis: false,
      randomNo: 0,
      rateInput: 0,
      COM: "",
      validationFlag: false,
      id: "today",
      keyValue: "TradeAnalysisReport",
      showRptDialog: false,
      checkRateModal: false,
      cmdty_metal: [],
      stkCodeList: [],
      selectedCmdtyDec: 2,
      formatRate: "",
    };
    this.onChangetrdAnaSearchValue = this.onChangetrdAnaSearchValue.bind(this);
    this.onChangeHiddenTrdAnalysisCol =
      this.onChangeHiddenTrdAnalysisCol.bind(this);
    this.handleKeypress = this.handleKeypress.bind(this);
    this.onRateInputKeyPress = this.onRateInputKeyPress.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
  }

  componentDidMount() {
    const thisComponent = ReactDOM.findDOMNode(this);
    //const allCssStyleRules = this.props.selectedCssColorTheme;
    //applyStyle(thisComponent, allCssStyleRules, elementsData);
    setDirection(
      ReactDOM.findDOMNode(this),
      directionData,
      this.props.selectedLang
    );
    const hoverElementsClassNames = [
      {
        elmToHover: thisComponent.getElementsByClassName("closeBtn")[0],
        classNames: "closeBtn",
      },
      {
        elmToHover: thisComponent.getElementsByClassName("button-l")[0],
        classNames: "button-l",
      },
    ];
    ////applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
    separator = getSeparator(navigator.language, "group");
    decimal = getSeparator(navigator.language, "decimal");
    try {
      this.setState({ loadtableflag: true });
      this.setState({ isRefreshDisabled: false });
    } catch (e) {
      console.log(e);
    }

    let tempCol1 = [...this.props.dropdown];
    var cmdty_metal = [...this.props.dropdown.cmdty_metal];

    this.setState({ cmdty_metal: cmdty_metal });
    let COM;
    var rateInput = 0;
    let stkPair;
    let dec;

    stkPair = this.props.stkCodeWisePair.get(tempCol1[0].cmdtId).pair;
    dec = this.props.instData.get(stkPair).dec;
    rateInput = Math.abs(this.props.socketAllRate.get(stkPair).bid);
    rateInput = rateInput.toLocaleString(navigator.language, {
      minimumFractionDigits: dec,
    });

    if (cmdty_metal.indexOf(tempCol1[0].cmdtId) !== -1) {
      COM = 1;
      this.setState({ qty_type: "" });
    } else {
      this.setState({ qty_type: this.props.stockCodeList[0].unit_code });
    }

    this.setState({
      rateInput: rateInput,
      formatRate: unformatLang(rateInput),
      COM: COM,
      cmdtyPairList: tempCol1,
      cmdty_Desc: tempCol1[0].cmdtDesc,
      cmdty_Id: tempCol1[0].cmdtId, //stockCode
      accountCode: this.props.DFA.C,
      stkCodeList: this.props.stockCodeList,
      qty_type: this.props.stockCodeList[0].unit_code,
      selectedCmdtyDec: dec,
    });
    const trade_type =
      this.state.onlineTrade + this.state.swapTrd + this.state.phoneTrd;
  }
  componentWillMount() {
    //this.props.loadAllRateData(true);
    const locale = locale;
    this.setState({
      locale: {
        format: "DD-MM-YYYY",
        applyLabel: i18next.t("apply"),
        cancelLabel: i18next.t("cancel"),
        customRangeLabel: i18next.t("customRange"),
        daysOfWeek: [
          i18next.t("su"),
          i18next.t("mo"),
          i18next.t("tu"),
          i18next.t("we"),
          i18next.t("th"),
          i18next.t("fr"),
          i18next.t("sa"),
        ],
        monthNames: [
          i18next.t("jan"),
          i18next.t("feb"),
          i18next.t("mar"),
          i18next.t("apr"),
          i18next.t("may"),
          i18next.t("jun"),
          i18next.t("jul"),
          i18next.t("aug"),
          i18next.t("sep"),
          i18next.t("oct"),
          i18next.t("nov"),
          i18next.t("dec"),
        ],
      },
    });
  }

  componentWillReceiveProps(nextProps, nextState) {
    // if(this.props.selectedCssColorTheme !== nextProps.selectedCssColorTheme){
    //   const thisComponent = ReactDOM.findDOMNode(this);
    //   const allCssStyleRules = nextProps.selectedCssColorTheme;
    //   applyStyle(thisComponent, allCssStyleRules, elementsData);
    // }
    if (this.props.selectedLang !== nextProps.selectedLang) {
      const thisComponent = ReactDOM.findDOMNode(this);
      setDirection(
        ReactDOM.findDOMNode(this),
        directionData,
        nextProps.selectedLang
      );
    }
    if (this.state.isClearTrdAnalysis !== this.props.isClearTrdAnalysis) {
      this.setState({ isClearTrdAnalysis: true });
      this.setState({ loadtableflag: true });
      this.setState({ isRefreshDisabled: true });
      this.setState({ startDate: new Date().toLocaleDateString("en-US") });
      this.setState({ endDate: new Date().toLocaleDateString("en-US") });
      this.setState({ currentDate: new Date().toLocaleDateString("en-US") });
      this.setState({ id: "today" });
    }
    if (nextProps.defAcc !== this.props.defAcc) {
      this.setState({ accountName: nextProps.defAcc.AD });
      this.setState({ accountCode: nextProps.defAcc.AC });
    }
    if (this.props.DFA.C !== nextProps.DFA.C) {
      this.setState({ accountCode: nextProps.DFA.C });
    }
    if (this.state.randomNo !== nextProps.trdAnalRptRandomNo) {
      var tempArr = [];
      var obj = nextProps.trdAnalData;
      this.setState({ trdAnalysisRows: tempArr.concat(obj) });
      this.setState({ loadtableflag: false });
      this.setState({ isRefreshDisabled: false });
      this.setState({ randomNo: nextProps.trdAnalRptRandomNo });
    }
  }
  
setStartDate = startDate => {
  try{
   this.setState({ startDate:startDate});
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'setStartDate', component:"TradeAnalysisReport"});
  }
}
setEndDate = endDate => {
  try{
    this.setState({ endDate:endDate });
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'setEndDate', component:"TradeAnalysisReport"});
  }
}

closeValidationModal=()=>{
  try{
    this.setState({validationFlag :false});
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'closeValidationModal', component:"TradeAnalysisReport"});
  }
}

onChangetrdAnaSearchValue(value){
  try{
    this.setState({searchValue: value });
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'onChangetrdAnaSearchValue', component:"TradeAnalysisReport"});
  }
}

onClickFilter = () => {
    try {
      if (this.state.rateInput === "") {
        this.setState({ checkRateModal: true });
      } else {
        this.setState({ loadtableflag : true });
        this.props.getTradeanalysisReport(
          this.state.accountCode,
          this.state.cmdty_Id,
          moment(this.state.startDate).format("DD-MM-YYYY"),
          moment(this.state.endDate).format("DD-MM-YYYY"),
          this.state.qty_type,
          this.state.formatRate,
          this.state.openBal,
          this.props.userDetail.LN,
          this.state.onlineTrade + this.state.swapTrd + this.state.phoneTrd
        );
      }
    } catch (e) {
      this.props.logFileCreation({ error: e.message, originFunction: 'onClickFilter', component: "TradeAnalysisReport" });
    }
  };

handleKeypress(e) {
  try{
    const characterCode = e.key;
    if (characterCode === "Backspace") return;

    const characterNumber = Number(characterCode);
    if (characterNumber >= 0 && characterNumber <= 9) {
      if (e.currentTarget.value && e.currentTarget.value.length) {
        return;
      } else if (characterNumber === 0) {
        e.preventDefault();
      }
    } else {
      e.preventDefault();
    }
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'handleKeypress', component:"TradeAnalysisReport"});
  }
}

changeAccount = (text, key) => {
    try {
      this.setState({
        accountName: text,
        accountCode: key,
        formatRate: unformatLang(this.state.rateInput),
      });
      //var checkDecimal =getSeparator(navigator.language,'decimal');
      if (this.state.rateInput === "") {
        this.setState({ checkRateModal: true });
      } else {
        this.setState({ checkRateModal: false, loadtableflag: true }, () => {
          this.onClickFilter();
        });
      }
    } catch (e) {
      this.props.logFileCreation({ error: e.message, originFunction: 'changeAccount', component: "TradeAnalysisReport" });
    }
  }

changeQty_type = (stk_code) => {
  try{
    this.setState({
      qty_type: stk_code,
      formatRate: unformatLang(this.state.rateInput),
    });
    //var checkDecimal =getSeparator(navigator.language,'decimal');
    if (this.state.rateInput === "") {
      this.setState({ checkRateModal: true });
    } else {
      this.setState({ checkRateModal: false, loadtableflag: true }, () => {
        this.onClickFilter();
      });
    }
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'changeQty_type', component:"TradeAnalysisReport"});
  }
}

handleAnalysisReport = (rate) =>{
  try{
    this.setState({ isRefreshDisabled: true, formatRate: unformatLang(rate) });
    //var checkDecimal =getSeparator(navigator.language,'decimal');
    if (rate === "") {
      this.setState({ checkRateModal: true });
    } else {
      this.setState({ checkRateModal: false, loadtableflag: true }, () => {
        this.onClickFilter();
      });
    }
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'handleAnalysisReport', component:"TradeAnalysisReport"});
  }
}

openBal = (event) => {
  try{
    this.setState({
      openBalcheck: event.target.checked,
      formatRate: unformatLang(this.state.rateInput),
    });
    var openBal = 0;
    //var checkDecimal =getSeparator(navigator.language,'decimal');
    if (event.target.checked) {
      this.setState({ openBal: 1 });
      openBal = 1;
    } else {
      this.setState({ openBal: 0 });
      openBal = 0;
    }
    if (this.state.rateInput === "") {
      this.setState({ checkRateModal: true });
    } else {
      this.setState({ checkRateModal: false, loadtableflag: true }, () => {
        this.onClickFilter();
      });
    }
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'openBal', component:"TradeAnalysisReport"});
  }
}

onlineTrade = (event) => {
  try{
    this.setState({
      onlineTradecheck: event.target.checked,
      formatRate: unformatLang(this.state.rateInput),
    });
    var onlineTrade = 0;
    if (event.target.checked) {
      this.setState({ onlineTrade: 1 });
      onlineTrade = 1;
    } else {
      this.setState({ onlineTrade: 0 });
      onlineTrade = 0;
    }
    if (this.state.rateInput === "") {
      this.setState({ checkRateModal: true });
    } else {
      this.setState({ checkRateModal: false, loadtableflag: true }, () => {
        this.onClickFilter();
      });
    }
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'onlineTrade', component:"TradeAnalysisReport"});
  }
}

swapTrd = (event) => {
  try{
    this.setState({
      swapTrdcheck: event.target.checked,
      formatRate: unformatLang(this.state.rateInput),
    });
    var swapTrd = 0;
    // var checkDecimal =getSeparator(navigator.language,'decimal');
    if (event.target.checked) {
      this.setState({ swapTrd: 2 });
      swapTrd = 2;
    } else {
      this.setState({ swapTrd: 0 });
      swapTrd = 0;
    }
    if (this.state.rateInput === "") {
      this.setState({ checkRateModal: true });
    } else {
      this.setState({ checkRateModal: false, loadtableflag: true }, () => {
        this.onClickFilter();
      });
    }
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'swapTrd', component:"TradeAnalysisReport"});
  }
}

phoneTrd = (event) => {
  try{
    this.setState({
      phoneTrdcheck: event.target.checked,
      formatRate: unformatLang(this.state.rateInput),
    });
    var phoneTrd = 0;
    // var checkDecimal =getSeparator(navigator.language,'decimal');
    if (event.target.checked) {
      this.setState({ phoneTrd: 4 });
      phoneTrd = 4;
    } else {
      this.setState({ phoneTrd: 0 });
      phoneTrd = 0;
    }
    if (this.state.rateInput === "") {
      this.setState({ checkRateModal: true });
    } else {
      this.setState({ checkRateModal: false, loadtableflag: true }, () => {
        this.onClickFilter();
      });
    }
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'phoneTrd', component:"TradeAnalysisReport"});
  }
}

dateHandle = (event, picker) => {
  try{
    this.setState({
      startDate: picker.startDate.format("DD-MM-YYYY"),
      endDate: picker.endDate.format("DD-MM-YYYY"),
    })
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'dateHandle', component:"TradeAnalysisReport"});
  }
}

handleCrossDoc = (commodity) => {
    try {
      let COM;
      let metalArray = [];
      const crossDocs = [1, 8, 32];

      for (let index = 0; index < this.props.socketDataStatic.length; index++) {
        if (this.props.socketDataStatic[index].B === 2 && this.props.socketDataStatic[index].C !== 4) {
          if (crossDocs.includes(this.props.socketDataStatic[index].C)) {
            metalArray.push(this.props.socketDataStatic[index].D1);
          } else {
            metalArray.push(this.props.socketDataStatic[index].D2);
          }
        }
      }

      for (const metal of metalArray) {
        if (metal === commodity) {
          COM = 2;
          break;
        } else {
          COM = 1;
        }
      }

      return COM;
    } catch (e) {
      this.props.logFileCreation({ error: e.message, originFunction: 'handleCrossDoc', component: "TradeAnalysisReport" });
    }
}

changeCmdtyPair = async (cmdtyid,cmdtyDesc) => {
  try{
    let COM;
    this.setState({ cmdty_Desc: cmdtyDesc });
    this.setState({ cmdty_Id: cmdtyid });
    var rateInput = 0;
    const stkPair = this.props.stkCodeWisePair.get(cmdtyid).pair;
    let dec;
    var checkSeparator = getSeparator(navigator.language, "group");
    COM = this.handleCrossDoc(cmdtyDesc);
    dec = this.props.instData.get(stkPair).dec;
    let qtyType;
    if (COM === 1) {
      qtyType = "";
    } else {
      qtyType = this.state.qty_type;
    }
    this.setState({
      rateInput: rateInput.toString().replace(checkSeparator, ""),
      formatRate: unformatLang(
        rateInput.toString().replace(checkSeparator, "")
      ),
      COM: COM,
      loadtableflag: true,
      selectedCmdtyDec: dec,
    });
    rateInput = rateInput.toString().replace(checkSeparator, "");
    rateInput = unformatLang(rateInput);
    const result = await this.props.getTradeanalysisReport(
      this.state.accountCode,
      cmdtyid,
      moment(this.state.startDate).format("DD-MM-YYYY"),
      moment(this.state.endDate).format("DD-MM-YYYY"),
      qtyType,
      rateInput,
      this.state.openBal,
      this.props.userDetail.LN,
      this.state.onlineTrade + this.state.swapTrd + this.state.phoneTrd
    );

    if (rateInput === 0 || rateInput === null || rateInput === "0") {
      rateInput = result.rate;
      this.setState({
        rateInput: rateInput.toString().replace(checkSeparator, ""),
        formatRate: unformatLang(
          rateInput.toString().replace(checkSeparator, "")
        ),
      });
    }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'changeCmdtyPair', component:"TradeAnalysisReport"});
    }
  }

  onChangeHiddenTrdAnalysisCol(hiddenCol){
    try{
      this.setState({ HiddentradeAnalysisCol : hiddenCol});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeHiddenTrdAnalysisCol', component:"TradeAnalysisReport"});
    }
  };
  
  changeFlag = () => {
    try{
      this.setState({showRptDialog: true});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'changeFlag', component:"TradeAnalysisReport"});
    }
  };

  closeRptModal = (event) => {
    try{
      this.setState({showRptDialog: false});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeRptModal', component:"TradeAnalysisReport"});
    }
  }

  closeRateModal = (event) => {
    try{
      this.setState({checkRateModal: false});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeRateModal', component:"TradeAnalysisReport"});
    }
  }

generatePdf=(format)=>{
  try{
    const startDate=moment(this.state.startDate).format('DD-MM-YYYY');
    const endDate= moment(this.state.endDate).format('DD-MM-YYYY');
    const tradeType = this.state.onlineTrade+this.state.swapTrd+this.state.phoneTrd;
    const user = JSON.parse(localStorage.getItem('user'));
    const platform = localStorage.getItem('platform');
    let response = '';
    let rate=this.state.rateInput;
    // let checkDecimal =getSeparator(navigator.language,'decimal');
    let formatRate =unformatLang(rate);
    let stkCode=this.state.cmdty_Id;
    let qty_Type=this.state.qty_type;
    const region = navigator.language;
    if(this.state.COM === 1){
      qty_Type=''
    }
    if(rate === ""){
      this.setState({checkRateModal:true});
    } else if (this.props.trdAnalData.length === 0 || this.props.trdAnalData === '' || this.props.trdAnalData === null) {
      this.setState({ showRptDialog: true });
    } else {
    if (format === 'PDF') {
      var xhr = new XMLHttpRequest();
        xhr.open('GET', getPath("api") + '/user/export_TrdAnalysis_pdf?startDate='+startDate+'&endDate='+endDate+'&stkType='+stkCode+
        '&qtyType='+qty_Type +'&rate='+formatRate+'&isOpen='+this.state.openBal+'&tradeType='+tradeType+'&langCode='+this.props.userDetail.LN+'&stkVal='+this.state.cmdty_Desc+'&region='+region);
        xhr.setRequestHeader('SID', this.props.userDetail.SID);
        xhr.setRequestHeader('username', this.props.userDetail.UID);
        xhr.setRequestHeader('location', user.location);
        xhr.setRequestHeader('Cache-Control','no-cache');
        xhr.setRequestHeader('accCode',this.state.accountCode);
        xhr.setRequestHeader('platform',platform);
        xhr.responseType = 'blob';
        xhr.onload = function (dispatch) {
        if(xhr.status === 200){
          filesaver.saveAs(xhr.response, "Trade_Analysis_Report_" + startDate + "_to_" + endDate + ".pdf");
        }else{
          this.changeFlag();
        }
      }.bind(this);
        xhr.send();
    } else {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', config.apiPath + '/user/export_TrdAnalysis_pdf?startDate='+startDate+'&endDate='+endDate+'&stkType='+stkCode+
        '&qtyType='+qty_Type +'&rate='+formatRate+'&isOpen='+this.state.openBal+'&tradeType='+tradeType+'&langCode='+this.props.userDetail.LN);
        xhr.setRequestHeader('SID', this.props.userDetail.SID);
        xhr.setRequestHeader('username', this.props.userDetail.UID);
        xhr.setRequestHeader('location', user.location);
        xhr.setRequestHeader('Cache-Control','no-cache');
        xhr.setRequestHeader('accCode',this.state.accountCode);
        xhr.setRequestHeader('platform',platform);
          xhr.responseType = 'blob';
          xhr.onload = function (e) {
            if(xhr.status === 200){
                filesaver.saveAs(xhr.response, "Trade_Analysis_Report_" + startDate + "_to_" + endDate + ".xlsx");
            }else{
              this.changeFlag();
            }
          }.bind(this);
          xhr.send();
      };
    }
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'generatePdf', component:"TradeAnalysisReport"});
  }
}

handleRateInput = (event) => {
  try{
    this.setState({rateInput: event.target.value, formatRate: unformatLang(event.target.value)});
    
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'handleRateInput', component:"TradeAnalysisReport"});
  }
}

onRateInputKeyPress = (event) => {
  try{
    // var formatRate = currencyFormatter.unformat(event.target.value,{locale:navigator.language});
    // var checkDecimal =getSeparator(navigator.language,'decimal');
    this.setState({ formatRate: unformatLang(event.target.value) });
    if (
      String.fromCharCode(event.which) != separator &&
      event.which > 31 &&
      (event.which < 48 || event.which > 57) &&
      String.fromCharCode(event.which) !== separator &&
      String.fromCharCode(event.which) !== decimal
    ) {
      event.preventDefault();
    }
    if (event.target.value.indexOf(decimal) === -1) {
      decimalCount = 0;
    }
    // if(event.which === separator.charCodeAt(0) || (event.which === decimal.charCodeAt(0) && decimalCount>=1)){
    //     event.preventDefault();
    // }
    if (event.which === decimal.charCodeAt(0)) {
      decimalCount += 1;
    }
    if (event.target.value.length == 0 && event.which == 48) {
      event.preventDefault();
    }
    if (
      event.target.value.length == 0 &&
      String.fromCharCode(event.which) == decimal
    ) {
      event.preventDefault();
    }
    const characterCode = event.key;
    if (characterCode === "Backspace") return;
    //  const characterNumber = characterCode
    //  console.log("characterNumber:"+characterNumber);
    // if (characterNumber >= 0 && characterNumber <= 9 ) {
    //   if (characterNumber === 0 ) {
    //     console.log("in characterNumber");
    //     event.preventDefault()
    //   }
    // } else {
    //   event.preventDefault()
    // }
    if (event.which === 13 /* Enter */) {
      this.setState({
        rateInput: event.target.value,
        formatRate: unformatLang(event.target.value),
      });
      if (event.target.value === "") {
        this.setState({ checkRateModal: true });
      } else {
        this.setState({ checkRateModal: false, loadtableflag: true }, () => {
          this.onClickFilter();
        });
      }
    }
  } catch (e) {
    this.props.logFileCreation({ error: e.message, originFunction: 'onRateInputKeyPress', component: "TradeAnalysisReport" });
  }
}

onBlurRateInputField = (event) => {
  try{
    //var checkDecimal = getSeparator(navigator.language,'decimal');
    // var formatRate = currencyFormatter.unformat(event.target.value,{locale:navigator.language});
    let formatRate = unformatLang(event.target.value);
    let rateInput = Number(parseFloat(formatRate)).toLocaleString(
      navigator.language,
      { minimumFractionDigits: this.state.selectedCmdtyDec }
    );
    this.setState({ rateInput: rateInput, formatRate: formatRate });
    if (event.target.value === "" || event.target.value == "0") {
      this.setState({ rateInput: "", checkRateModal: true });
    } else {
      this.setState({ checkRateModal: false, loadtableflag: true }, () => {
        this.onClickFilter();
      });
    }
  } catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onBlurRateInputField', component:"TradeAnalysisReport"});
    }
}

afterOpenModal() {
  try {
    const thisComponent = this.refs.errorMSG;
    //const allCssStyleRules = this.props.selectedCssColorTheme;
    const elementsData = [
      { "classNames": "closeBtn", "elementType": "normal", "applyTo": "single", "tagNames": "div" },
      { "classNames": "button-l", "elementType": "normal", "applyTo": "single", "tagNames": "button" },
    ];
    // applyStyle(thisComponent, allCssStyleRules, elementsData);
    const directionData = [
      { "classNames": "header", "elementType": "normal", "applyTo": "all", "tagNames": "div" },
      { "classNames": "commonCloseIcon", "elementType": "normal", "applyTo": "all", "tagNames": "div" },
      { "classNames": "commonMsgDir", "elementType": "normal", "applyTo": "all", "tagNames": "div" },
      { "classNames": "button-l", "elementType": "normal", "applyTo": "single", "tagNames": "button" },
    ];
    setDirection(thisComponent, directionData, this.props.selectedLang);
    const hoverElementsClassNames = [
      { "elmToHover": thisComponent.getElementsByClassName("closeBtn")[0], "classNames": "closeBtn" },
      { "elmToHover": thisComponent.getElementsByClassName("button-l")[0], "classNames": "button-l" },
    ];
    ////applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
  } catch (e) {
    this.props.logFileCreation({ error: e.message, originFunction: 'afterOpenModal', component: "TradeAnalysisReport" });
  }
 }

  render() {
    const {
      startDate,
      endDate,
      cmdty_Desc,
      accountName,
      accountCode,
      openBal,
      onlineTrade,
      swapTrd,
      phoneTrd,
      qty_type,
      cmdty_Id,
      COM,
    } = this.state;
    let label = startDate + " - " + endDate;
    const tradeType = onlineTrade + swapTrd + phoneTrd;
    if (startDate === endDate) {
      label = startDate;
    }
    var cmdtyLable;
    cmdtyLable =
      this.props.language == "AR"
        ? "(" + qty_type + ") " + cmdty_Desc
        : cmdty_Desc + " (" + qty_type + ")";
    if (this.state.COM == 1) {
      cmdtyLable = cmdty_Desc;
    }
    var valueLable =
      i18next.t("value") +
      " " +
      "(" +
      this.props.localCurrency[0].basecurrency +
      ")";

    const trdAnaColumns = [
      { name: "D", title: i18next.t("description"), width: { wpx: 300 } },
      { name: "Q", title: cmdtyLable, width: { wpx: 150 } },
      { name: "AMT", title: valueLable, width: { wpx: 150 } },
      { name: "AVG", title: i18next.t("average"), width: { wpx: 150 } },
    ];
    var tableData = [];
    var propData = this.props.trdAnalData;

    for (let i = 0; i < propData.length; i++) {
      tableData[i] = [
        {
          value: propData[i].D,
          style: { alignment: { wrapText: true, horizontal: "left" } },
        },
        {
          value: propData[i].Q,
          style: { alignment: { wrapText: true, horizontal: "right" } },
        },
        {
          value: propData[i].AMT,
          style: { alignment: { wrapText: true, horizontal: "right" } },
        },
        {
          value: propData[i].AVG,
          style: { alignment: { wrapText: true, horizontal: "right" } },
        },
      ];
    }

    let multiDataSet = [
      {
        columns: trdAnaColumns,
        data: tableData,
      },
    ];
    const pagingPanelMessages = {
      showAll: i18next.t("all"),
      rowsPerPage: i18next.t("rowsPerPage"),
      info: "",
    };
    const rowStyle = (theme) => ({
      tableStriped: {
        "& tbody tr:nth-of-type(odd)": {
          //backgroundColor: this.props.selectedCssColorTheme.listRow.background,
          //color:this.props.selectedCssColorTheme.listRow.color
        },
        "& tbody tr:nth-of-type(even)": {
          // backgroundColor: this.props.selectedCssColorTheme.rptListRowNext.background,
          // color:this.props.selectedCssColorTheme.listRow.color
        },
        "& thead th": {
          //color:this.props.selectedCssColorTheme.tableHeaderColor.color
        },
        "& .text-primary": {
          //color: this.props.selectedCssColorTheme.activeHeaderColor.color
        },
      },
    });
    const TableComponentBase = ({ classes, ...restProps }) => (
      <Table.Table {...restProps} className={classes.tableStriped} />
    );
    const TableRow = ({ row, ...restProps }) => (
      <Table.Row
        {...restProps}
        className={row.isBold === true ? "trdAnalysisRowsStyle" : null}
      />
    );
    var NoDataMsg = {
      noData: "",
    };
    if (this.state.loadtableflag === true) {
      NoDataMsg.noData = "";
    } else {
      NoDataMsg.noData = i18next.t("noDataAvlMsg");
    }
    const NoDataCell = (props) => (
      <Table.NoDataCell {...props} className="noDataCell" />
    );
    return (
      <div className={`${this.props.language}`} id="tradeAnaRpt">
        <Modal
          isOpen={this.state.validationFlag}
          className={styles.warningModal}
          onAfterOpen={this.afterOpenModal}
        >
          <div ref="errorMSG" className="mdlWrap">
            <div className={`${styles.header} header`}>
              {i18next.t("error")}
              <span
                onClick={this.closeValidationModal}
                className={`${styles.closeImg} closeIcon`}
              >
                {this.props.closeIcon}
              </span>
            </div>
            <div className={`${styles.msg} commonMsgDir`}>
              <h4>{i18next.t("dateSelectorErrMsg")}</h4>
            </div>
          </div>
        </Modal>
        <Modal
          isOpen={this.state.showRptDialog}
          className={styles.warningModal}
          id="TrdAnalRptModal"
          onAfterOpen={this.afterOpenModal}
        >
          <div ref="errorMSG" className="mdlWrap">
            <div className={`${styles.header} header`}>
              <span className={`${styles.msgTitle}`}>
                {i18next.t("trdAnalRpt")}
              </span>
              <span
                onClick={this.closeRptModal}
                className={`${styles.closeImg} closeIcon`}
                id="idlRptCloseIcon"
              >
                {this.props.closeIcon}
              </span>
            </div>
            <div className={`${styles.msg} commonMsgDir`}>
              {i18next.t("noDataAvlMsg")}
            </div>
            <div className={`${styles.btnWrap} col-md-12`}>
              <Button
                className="button-l"
                bsStyle="primary"
                onClick={this.closeRptModal}
                id="idlRptCloseBtn"
              >
                {i18next.t("OK")}
              </Button>
            </div>
          </div>
        </Modal>
        <Modal
          isOpen={this.state.checkRateModal}
          className={styles.warningModal}
          id="TrdAnalRptModal"
          onAfterOpen={this.afterOpenModal}
        >
          <div ref="errorMSG" className="mdlWrap">
            <div className={`${styles.header} header`}>
              <span className={`${styles.msgTitle}`}>
                {i18next.t("trdAnalRpt")}
              </span>
            </div>
            <span
              onClick={this.closeRateModal}
              className={`${styles.closeImg} closeIcon`}
              id="idlRptCloseIcon"
            >
              {this.props.closeIcon}
            </span>
            <div className={`${styles.msg} commonMsgDir`}>
              {i18next.t("trnAnlValidRateMsg")}
            </div>
            <div className={`${styles.btnWrap} col-md-12`}>
              <Button
                className="button-l"
                bsStyle="primary"
                onClick={this.closeRateModal}
                id="idlRptCloseBtn"
              >
                {i18next.t("OK")}
              </Button>
            </div>
          </div>
        </Modal>
        <div
          className={`${styles.trdAnafilterBar} trdAnafilterBar ${this.props.selectedCssColor}`}
        >
          <div className={`${styles.trdAnafilterBarInner} fltrBarInner`}>
            <div className={styles.flexWrapper}>
              <div className={styles.optionsWrapper}>
                <div
                  className={`${styles.trdAnawrapper1} SOAaccountList trdAnlDrpdownDiv`}
                  id="tradeAnalAcc"
                >
                  <DropdownButton
                    title={accountName}
                    id="bg-nested-dropdown"
                    className={`${styles.PoskeepingAcc} reportsDropdown btnText`}
                  >
                    {this.state.accountList.map((item) => {
                      return (
                        <MenuItem
                          onClick={() => this.changeAccount(item.D, item.C)}
                          id="rptPosAccListMenu"
                        >
                          {item.D}
                        </MenuItem>
                      );
                    })}
                  </DropdownButton>
                </div>
                <div
                  className={`${styles.trdAnaselectDatebtn} trdAnlDrpdownDiv`}
                  id="trdAnaDate"
                >
                  <DateSelector
                    keyValue={this.state.keyValue}
                    onClickFilter={this.onClickFilter}
                    setStartDate={this.setStartDate}
                    setEndDate={this.setEndDate}
                    component='Report'
                  />
                </div>
                <div
                  className={`${styles.trdAnawrapper1} SOAaccountList trdAnlDrpdownDiv`}
                  id="trdAnasecondwrapper2"
                >
                  <TcoDropdown
                    parentDivClassname={`${styles.trdAnaCmdtfilterItem}`}
                    parentDivId="ScrollCss"
                    dropdownTitle={cmdty_Desc}
                    dropdownId="bg-nested-dropdown"
                    dropdownData={this.state.cmdtyPairList}
                    dataItemClick={this.changeCmdtyPair}
                    dropdownClassname="btnText"
                  />
                </div>
                <div
                  className={`${styles.trdAnawrapper1} SOAaccountList trdAnlDrpdownDiv`}
                  id="trdAnasecondwrapper"
                >
                  <input
                    type="text"
                    placeholder={i18next.t("rate")}
                    id="rateInput"
                    onKeyPress={this.onRateInputKeyPress}
                    onBlur={this.onBlurRateInputField}
                    onChange={this.handleRateInput}
                    min="0"
                    step="1"
                    lang={navigator.language}
                    value={this.state.rateInput}
                    className="rateInput"
                  />
                </div>
                <div
                  className={`${styles.trdAnawrapper1} SOAaccountList trdAnlDrpdownDiv`}
                  id="trdAnasecondwrapperqty"
                >
                  <DropdownButton
                    title={qty_type}
                    id="dropdown-size-medium"
                    className={`${styles.PoskeepingAcc} reportsDropdown btnText`}
                    disabled={this.state.COM === 1}
                  >
                    {this.state.stkCodeList.map((item) => {
                      return (
                        <MenuItem
                          onClick={() => this.changeQty_type(item.unit_code)}
                          id="trdMeasureMkt"
                        >
                          {item.unit_code}
                        </MenuItem>
                      );
                    })}
                  </DropdownButton>
                </div>
              </div>
              <div className={styles.exportOptions}>
                <div className={`${styles.exportfileBaracc} allExportFilter`}>
                  <div className={`${styles.accfilterItem} commonGoBtn`}>
                    <button
                      type="button"
                      className={
                        this.state.isRefreshDisabled === true
                          ? `${styles.disabled} ${styles.goBtn}`
                          : `${styles.goBtn}`
                      }
                      id="trdAnlyRptBtn"
                      onClick={() =>
                        this.handleAnalysisReport(
                          accountCode,
                          cmdty_Id,
                          startDate,
                          endDate,
                          qty_type,
                          this.state.rateInput,
                          openBal,
                          this.props.userDetail.LN,
                          tradeType
                        )
                      }
                    >
                     {this.props.refreshIcon}
                    </button>
                  </div>
                  <label className={this.state.loadtableflag === true ? "disableLabel" : null}>
                    {this.props.trdAnalData.length !== 0 && (
                      <span>
                        <ExcelFile
                          filename="TradeAnalysisReport"
                          element={<img src="/images/xls.png" />}
                        >
                          <ExcelSheet
                            dataSet={multiDataSet}
                            name="TradeAnalysisReport"
                          />
                        </ExcelFile>
                      </span>
                    )}
                    {this.props.trdAnalData.length === 0 && (
                      <img src="/images/xls.png" onClick={this.changeFlag} />
                    )}
                    <span>
                      <img
                        src="/images/pdf.png"
                        onClick={() => {
                          this.generatePdf("PDF");
                        }}
                      />
                    </span>
                  </label>
                </div>
              </div>
            </div>

            <div className={styles.checkbxdiv} id="trdAnalysisCheckBoxDiv">
              <div
                className={`${styles.trdwrapper1} trdwrapper1`}
                id="firstwrapper"
              >
                <div className={styles.trdfilterItemcol1} id="SOAcol1Dropdown">
                  <label className={`${styles.containerClass} cust-box`}>
                    <input
                      type="checkbox"
                      className={styles.column1_checkbox}
                      checked={this.state.openBalcheck}
                      onChange={this.openBal}
                    />
                    <span className={`${styles.checkmark} checkmark`}></span>
                  </label>
                  <label className={`${styles.column1_lbl} trdAnalChkLabel`}>
                    {i18next.t("excludeOpnBal")}
                  </label>
                </div>
              </div>
              <div
                className={`${styles.trdwrapper1} trdwrapper1`}
                id="firstwrapper"
              >
                <div className={styles.trdfilterItemcol1} id="SOAcol1Dropdown">
                  <label className={`${styles.containerClass} cust-box`}>
                    <input
                      type="checkbox"
                      className={styles.column1_checkbox}
                      checked={this.state.onlineTradecheck}
                      onChange={this.onlineTrade}
                    />
                    <span className={`${styles.checkmark} checkmark`}></span>
                  </label>
                  <label className={`${styles.column1_lbl} trdAnalChkLabel`}>
                    {i18next.t("excludePlatformTrd")}
                  </label>
                </div>
              </div>
              <div
                className={`${styles.trdwrapper1} trdwrapper1`}
                id="firstwrapper"
              >
                <div className={styles.trdfilterItemcol1} id="SOAcol1Dropdown">
                  <label className={`${styles.containerClass} cust-box`}>
                    <input
                      type="checkbox"
                      className={styles.column1_checkbox}
                      checked={this.state.phoneTrdcheck}
                      onChange={this.phoneTrd}
                    />
                    <span className={`${styles.checkmark} checkmark`}></span>
                  </label>
                  <label className={`${styles.column1_lbl} trdAnalChkLabel`}>
                    {i18next.t("excludePhnTrd")}
                  </label>
                </div>
              </div>
              <div
                className={`${styles.trdwrapper1} trdwrapper1`}
                id="firstwrapper"
              >
                <div className={styles.trdfilterItemcol1} id="SOAcol1Dropdown">
                  <label className={`${styles.containerClass} cust-box`}>
                    <input
                      type="checkbox"
                      className={styles.column1_checkbox}
                      checked={this.state.swapTrdcheck}
                      onChange={this.swapTrd}
                    />
                    <span className={`${styles.checkmark} checkmark`}></span>
                  </label>
                  <label className={`${styles.column1_lbl} trdAnalChkLabel`}>
                    {i18next.t("excludeSwap")}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className={`${styles.tradeAnalysisReportb1} tradeAnalysisReportb1`}
          id="tradeAnalysisReportb1"
        >
          {this.state.loadtableflag === true ? (
            <div className={styles.rptoverlay}>
              <i className="fa fa-spinner fa-spin spin-big"></i>
            </div>
          ) : null}
          <div className={`${styles.tradeAnalysisReport} reportsTblGrid`}>
            <Grid rows={this.state.trdAnalysisRows} columns={trdAnaColumns}>
              <SearchState
                value={this.state.searchValue}
                onValueChange={this.onChangetrdAnaSearchValue}
              />
              <IntegratedFiltering />
              <Table
                tableComponent={withStyles(rowStyle, {
                  name: "TableComponent",
                })(TableComponentBase)}
                columnAutoWidth={true}
                rowComponent={TableRow}
                messages={NoDataMsg}
                noDataCellComponent={NoDataCell}
              />
              <TableHeaderRow />
              <TableColumnVisibility
                hiddenColumnNames={this.state.HiddentradeAnalysisCol}
                onHiddenColumnNamesChange={this.onChangeHiddenTrdAnalysisCol}
              />
              <Toolbar />
            </Grid>
          </div>
        </div>
      </div>
    );
  }
}
